import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Legal.scss';
import SEO from '../../components/SEO';
const MentionsLegales = () => {
    const { t } = useTranslation();
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="kanem-legal-page">
            <SEO title="Mentions légales" description="Mentions légales du site kanemx.com. Éditeur, hébergement et propriété intellectuelle." url="/mentions-legales" />

            <div className="kanem-legal-hero">
                <div className="kanem-grain"></div>
                <div className="kanem-legal-hero-content">
                    <p className="kanem-eyebrow">{t('legal.eyebrow')}</p>
                    <h1 className="kanem-legal-title">{t('legal.mentions_title')}</h1>
                    <p className="kanem-legal-date">{t('legal.last_updated')}</p>
                </div>
            </div>

            <div className="kanem-legal-body">
                <div className="kanem-legal-inner">

                    <section className="kanem-legal-section">
                        <h2>{t('legal.mentions.editor_title')}</h2>
                        <p>{t('legal.mentions.editor_company')}</p>
                        <p>{t('legal.mentions.editor_address')}</p>
                        <p>{t('legal.mentions.editor_website')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.mentions.hosting_title')}</h2>
                        <p>{t('legal.mentions.hosting_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.mentions.ip_title')}</h2>
                        <p>{t('legal.mentions.ip_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.mentions.liability_title')}</h2>
                        <p>{t('legal.mentions.liability_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.mentions.data_title')}</h2>
                        <p>{t('legal.mentions.data_desc')}</p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default MentionsLegales;
